import { ContextMenu } from "@smart/itops-sb-design-system-dom";

import { EmbedType } from "./embed-options";
import { LinkItemType, SubmissionLink } from "./types";
import { CellProps } from "../../types";

export const LinkTableActions =
  ({
    onEdit,
    onDelete,
    onCopy,
    onGenerateQRCode,
  }: Record<
    "onEdit" | "onDelete" | "onCopy" | "onGenerateQRCode",
    (link: SubmissionLink, options?: { copyType: EmbedType }) => void
  >) =>
  ({ row }: CellProps<LinkItemType>) => (
    <ContextMenu
      button={{
        className: "w-[2rem] h-[2rem]",
        variant: "secondarySubtle",
        leftIcon: "solidEllipsis",
      }}
      placement="bottom"
      items={[
        {
          label: "Change Settings",
          onClick: () => onEdit(row.original.link),
        },
        {
          label: "Delete Link",
          onClick: () => onDelete(row.original.link),
        },
        {
          label: 'Copy "Link"',
          onClick: () => onCopy(row.original.link, { copyType: "url" }),
        },
        {
          label: 'Copy "Embedded"',
          onClick: () => onCopy(row.original.link, { copyType: "iframe" }),
        },
        {
          label: 'Copy "Contact Us"',
          onClick: () => onCopy(row.original.link, { copyType: "button" }),
        },
        {
          label: "Show QR Code",
          onClick: () => onGenerateQRCode(row.original.link),
        },
      ]}
    />
  );
